<template>
  <div class="agent-page">
    <div class="page-header">
      <h2 class="page-title">招标文件详情</h2>
      <el-button type="primary" icon="el-icon-back" @click="handleBack">返回</el-button>
    </div>
    <div class="content-wrap">
      <!-- 基本信息 -->
      <div class="section-block">
        <div class="section-title">基本信息</div>
        <el-row :gutter="20" class="detail-row">
          <el-col :span="12">
            <div class="field">
              <span class="label">招标文件编号：</span>
              <span class="value">{{ detailData.bidInvitationDocumentsCode || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">招标文件名称：</span>
              <span class="value">{{ detailData.bidInvitationDocumentsName || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">文件类型：</span>
              <span class="value">{{ getDocumentTypeText(detailData.documentType) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">文件编制状态：</span>
              <span class="value">{{ getDocumentStatusText(detailData.documentPreparationStatus) }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">开标时间：</span>
              <span class="value">{{ detailData.bidOpeningTime || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">解密截止时间：</span>
              <span class="value">{{ detailData.decryptionDeadline || '-' }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">创建时间：</span>
              <span class="value">{{ detailData.createTime || '-' }}</span>
            </div>
          </el-col>
           <el-col :span="12">
            <div class="field">
              <span class="label">质疑提出截止时间：</span>
              <span class="value">{{ detailData.bidSectionConfig.questionDeadline || '-' }}</span>
            </div>
          </el-col>
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">状态：</span>
              <span class="value">{{ getStatusText(detailData.status) }}</span>
            </div>
          </el-col> -->
        </el-row>
      </div>

      <!-- 标段配置信息 -->
      <!-- <div class="section-block" v-if="detailData.bidSectionConfig"> -->
        <!-- <div class="section-title">标段配置信息</div>
        <el-row :gutter="20" class="detail-row">
          <el-col :span="12">
            <div class="field">
              <span class="label">标段编号：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidSectionCode || '-' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">开标时间：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidOpeningTime || '-' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">标段名称</span>
              <span class="value">{{ detailData.bidSectionName || '-' }}</span>
            </div>
          </el-col> -->

          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">暗标评审：</span>
              <span class="value">{{ detailData.bidSectionConfig.isBlindReview === 1 ? '暗标' : '明标' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">价款形式代码：</span>
              <span class="value">{{ getPriceFormText(detailData.bidSectionConfig.priceFormCode) }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">投标有效期：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidValidity ? detailData.bidSectionConfig.bidValidity +
                '天' : '-' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">是否收取保证金：</span>
              <span class="value">{{ detailData.bidSectionConfig.isChargeDepositPayment === 1 ? '是' : '否' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">保证金金额：</span>
              <span class="value">{{ formatDepositPayment(detailData.bidSectionConfig.depositPayment,
                detailData.bidSectionConfig.depositPaymentUnit) }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">是否验证保证金/保函：</span>
              <span class="value">{{ detailData.bidSectionConfig.isVerifyDepositPayment === 1 ? '是' : '否' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">招标控制价：</span>
              <span class="value">{{ formatTenderControlPrice(detailData.bidSectionConfig.tenderControlPrice,
                detailData.bidSectionConfig.tenderControlPriceUnit) }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">评审办法：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidEvaluationMethod || '-' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">文件开启方法：</span>
              <span class="value">{{ detailData.bidSectionConfig.bidDecryptionMethod || '-' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">是否允许联合体投标：</span>
              <span class="value">{{ detailData.bidSectionConfig.jointBiddingIsPermitted === 1 ? '是' : '否' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">是否需要资格审查：</span>
              <span class="value">{{ detailData.bidSectionConfig.qualificationReviewIsRequired === 1 ? '是' : '否'
              }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="field">
              <span class="label">是否需要报名：</span>
              <span class="value">{{ detailData.bidSectionConfig.isNeedRegister === 1 ? '是' : '否' }}</span>
            </div>
          </el-col> -->
          <!-- <el-col :span="12">
            <div class="field">
              <span class="label">投标文件递交方法：</span>
              <span class="value">{{ detailData.bidSectionConfig.submissionMethods || '-' }}</span>
            </div>
          </el-col> -->
        <!-- </el-row> -->
      <!-- </div> -->

      <!-- 标段信息列表 -->
      <div class="section-block" v-if="detailData.bidSectionList && detailData.bidSectionList.length > 0">
        <div class="section-title">标段信息</div>
        <el-table :data="detailData.bidSectionList" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="标段编号" prop="bidSectionCode" min-width="180"></el-table-column>
          <el-table-column label="标段名称" prop="bidSectionName" min-width="300"></el-table-column>
          <!-- <el-table-column label="是否已选择" prop="isSelected" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.isSelected === 1 ? 'success' : 'info'" size="small">
                {{ scope.row.isSelected === 1 ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!-- 招标文件正文 -->
      <div class="section-block" v-if="mainFileList.length > 0">
        <div class="section-title">
          <i class="el-icon-document"></i> 招标文件正文
          <el-tag size="mini" type="info" style="margin-left:8px;">{{ mainFileList.length }} 份</el-tag>
        </div>
        <el-table :data="mainFileList" border stripe size="small">
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column label="文件名称" prop="fileName" min-width="260" show-overflow-tooltip></el-table-column>
          <el-table-column label="格式" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.fileExtension === 'pdf' ? 'danger' : 'primary'">
                {{ (scope.row.fileExtension || '-').toUpperCase() }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="文件大小" width="110" align="center">
            <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDownloadFile(scope.row)">
                <i class="el-icon-download"></i> 下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 附件 -->
      <div class="section-block" v-if="attFileList.length > 0">
        <div class="section-title">
          <i class="el-icon-paperclip"></i> 附件
          <el-tag size="mini" type="info" style="margin-left:8px;">{{ attFileList.length }} 份</el-tag>
        </div>
        <el-table :data="attFileList" border stripe size="small">
          <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
          <el-table-column label="文件名称" prop="fileName" min-width="260" show-overflow-tooltip></el-table-column>
          <el-table-column label="格式" width="80" align="center">
            <template slot-scope="scope">
              <el-tag size="mini"
                :type="scope.row.fileExtension === 'pdf' ? 'danger' : ['doc','docx'].includes(scope.row.fileExtension) ? 'primary' : 'warning'">
                {{ (scope.row.fileExtension || '-').toUpperCase() }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="文件大小" width="110" align="center">
            <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDownloadFile(scope.row)">
                <i class="el-icon-download"></i> 下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 开标一览表 -->
      <div class="section-block" v-if="detailData.bidOpeningLists && detailData.bidOpeningLists.length > 0">
        <div class="section-title section-title--action">
          <span>开标一览表</span>
          <template v-if="!editingOpening">
            <el-button v-if="canEdit" type="text" size="small" icon="el-icon-edit" @click="startEditOpening">修改</el-button>
          </template>
          <template v-else>
            <span>
              <el-button type="primary" size="mini" @click="saveOpening" :loading="savingOpening">保存</el-button>
              <el-button size="mini" @click="cancelEditOpening">取消</el-button>
            </span>
          </template>
        </div>
        <el-table :data="editingOpening ? editOpeningList : detailData.bidOpeningLists" border stripe>
          <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
          <el-table-column label="项目名称" min-width="150">
            <template slot-scope="scope">
              <el-input v-if="editingOpening" v-model="scope.row.itemName" size="small" placeholder="项目名称" />
              <span v-else>{{ scope.row.itemName || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="填报内容类型" width="140" align="center">
            <template slot-scope="scope">
              <el-select v-if="editingOpening" v-model="scope.row.itemValueType" size="small" style="width:100%">
                <el-option label="任意文本" :value="0" />
                <el-option label="纯数字" :value="1" />
              </el-select>
              <span v-else>{{ getItemValueTypeText(scope.row.itemValueType) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位" width="100" align="center">
            <template slot-scope="scope">
              <el-select v-if="editingOpening" v-model="scope.row.itemUnit" size="small" style="width:100%">
                <el-option label="元" :value="0" />
                <el-option label="万元" :value="1" />
                <el-option label="%" :value="2" />
              </el-select>
              <span v-else>{{ getItemUnitText(scope.row.itemUnit) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="填报说明" min-width="200">
            <template slot-scope="scope">
              <el-input v-if="editingOpening" v-model="scope.row.itemInstructions" size="small" placeholder="填报说明" />
              <span v-else>{{ scope.row.itemInstructions || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="!editingOpening" label="创建时间" prop="createTime" width="180"></el-table-column>
          <el-table-column v-if="editingOpening" label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" style="color:#f56c6c" @click="editOpeningList.splice(scope.$index, 1)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-if="editingOpening" type="primary" size="mini" icon="el-icon-plus" @click="addOpeningRow" style="margin-top:10px;">添加行</el-button>
      </div>

      <!-- 目录结构 -->
      <div class="section-block" v-if="detailData.catalogues && detailData.catalogues.length > 0">
        <div class="section-title section-title--action">
          <span>文件目录</span>
          <template v-if="!editingCatalogue">
            <el-button v-if="canEdit" type="text" size="small" icon="el-icon-edit" @click="startEditCatalogue">修改</el-button>
          </template>
          <template v-else>
            <span>
              <el-button type="primary" size="mini" @click="saveCatalogue" :loading="savingCatalogue">保存</el-button>
              <el-button size="mini" @click="cancelEditCatalogue">取消</el-button>
            </span>
          </template>
        </div>
        <!-- 编辑模式：树形编辑 -->
        <template v-if="editingCatalogue">
          <div class="catalogue-edit-toolbar">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addRootNode">添加根目录</el-button>
          </div>
          <div class="catalogue-edit-tree">
            <div v-if="editCatalogueTree.length === 0" class="empty-directory">
              <i class="el-icon-folder-opened"></i>
              <p>暂无目录，请添加</p>
            </div>
            <div v-else class="directory-list">
              <!-- 一级目录 -->
              <div v-for="(item, index) in editCatalogueTree" :key="item.strId" class="directory-item">
                <div class="directory-node">
                  <i class="el-icon-folder"></i>
                  <el-input v-model="item.catalogueName" size="small" placeholder="目录名称" class="dir-name-input" />
                  <el-input v-model="item.catalogueDescription" size="small" placeholder="目录描述" class="dir-desc-input" />
                  <div class="directory-actions">
                    <el-button type="text" size="small" icon="el-icon-plus" @click="addChildNode(item)"></el-button>
                    <el-button type="text" size="small" icon="el-icon-delete" @click="removeTreeNode(editCatalogueTree, index)"></el-button>
                  </div>
                </div>
                <!-- 二级目录 -->
                <div v-if="item.children && item.children.length > 0" class="directory-children">
                  <div v-for="(child, childIndex) in item.children" :key="child.strId" class="directory-item child-item">
                    <div class="directory-node">
                      <i class="el-icon-folder"></i>
                      <el-input v-model="child.catalogueName" size="small" placeholder="目录名称" class="dir-name-input" />
                      <el-input v-model="child.catalogueDescription" size="small" placeholder="目录描述" class="dir-desc-input" />
                      <div class="directory-actions">
                        <el-button type="text" size="small" icon="el-icon-plus" @click="addChildNode(child)"></el-button>
                        <el-button type="text" size="small" icon="el-icon-delete" @click="removeTreeNode(item.children, childIndex)"></el-button>
                      </div>
                    </div>
                    <!-- 三级目录 -->
                    <div v-if="child.children && child.children.length > 0" class="directory-children">
                      <div v-for="(grandchild, gcIndex) in child.children" :key="grandchild.strId" class="directory-item grandchild-item">
                        <div class="directory-node">
                          <i class="el-icon-folder"></i>
                          <el-input v-model="grandchild.catalogueName" size="small" placeholder="目录名称" class="dir-name-input" />
                          <el-input v-model="grandchild.catalogueDescription" size="small" placeholder="目录描述" class="dir-desc-input" />
                          <div class="directory-actions">
                            <el-button type="text" size="small" icon="el-icon-delete" @click="removeTreeNode(child.children, gcIndex)"></el-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 查看模式：树形展示 -->
        <template v-else>
          <el-tree :data="detailData.catalogues" :props="treeProps" node-key="strId" default-expand-all
            class="catalogue-tree">
            <span class="custom-tree-node" slot-scope="{ data }">
              <span>
                <i class="el-icon-folder-opened" style="color: #409EFF; margin-right: 5px;"></i>
                {{ data.catalogueName }}
              </span>
              <span style="color: #999; font-size: 12px; margin-left: 10px;">
                {{ data.catalogueDescription }}
              </span>
            </span>
          </el-tree>
        </template>
      </div>
    </div>

    <!-- 添加自定义开标内容弹窗 -->
    <el-dialog title="消息确认" :visible.sync="dialogs.addOpeningType" width="500px" :close-on-click-modal="false"
      :append-to-body="true" class="add-dialog">
      <div class="dialog-content">
        <div class="dialog-title">*添加自定义内容的类型:</div>
        <el-radio-group v-model="addOpeningTypeDialogData.selectedType" class="type-radio-group">
          <div class="radio-row">
            <el-radio label="总价">总价</el-radio>
            <el-radio label="费率">费率</el-radio>
            <el-radio label="单价">单价</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="证书编号">证书编号</el-radio>
            <el-radio label="交货地点">交货地点</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="期限(服务/交货/工期)">期限(服务/交货/工期)</el-radio>
            <el-radio label="其它">其它</el-radio>
          </div>
          <div class="radio-row">
            <el-radio label="姓名">姓名</el-radio>
            <el-radio label="质量标准">质量标准</el-radio>
          </div>
        </el-radio-group>
        <div v-if="!addOpeningTypeDialogData.selectedType" class="error-message">请选择自定义内容的类型</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmAddOpeningRow">确认</el-button>
        <el-button @click="cancelAddOpeningRow">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBidInvitationDocumentsDetail, updateBidOpeningListAndCatalogue } from '@/api/modules/agent'
import { getFileList } from '@/api/modules/base'

export default {
  name: 'DetailUploadFile',
  data() {
    return {
      bidInvitationDocumentsCode: '',
      detailData: {},
      fileList: [],
      treeProps: {
        children: 'children',
        label: 'catalogueName'
      },
      // 开标一览表独立编辑
      editingOpening: false,
      savingOpening: false,
      editOpeningList: [],
      // 目录独立编辑
      editingCatalogue: false,
      savingCatalogue: false,
      editCatalogueTree: [],

      // 弹窗控制
      dialogs: {
        addOpeningType: false
      },

      // 添加开标内容弹窗相关数据
      addOpeningTypeDialogData: {
        selectedType: ''
      },

      // 类型对应的数据格式配置
      openingTypeConfig: {
        '总价': { valueType: 1, unit: 0 },
        '费率': { valueType: 1, unit: 2 },
        '单价': { valueType: 1, unit: 0 },
        '证书编号': { valueType: 0, unit: 0 },
        '交货地点': { valueType: 0, unit: 0 },
        '期限(服务/交货/工期)': { valueType: 0, unit: 0 },
        '其它': { valueType: 0, unit: 0 },
        '姓名': { valueType: 0, unit: 0 },
        '质量标准': { valueType: 0, unit: 0 }
      },

      // 类型到 itemType 的映射（与 creatBidFile 一致）
      openingItemTypeMap: {
        '总价': '1',
        '费率': '2',
        '单价': '3',
        '证书编号': '4',
        '交货地点': '5',
        '期限(服务/交货/工期)': '6',
        '姓名': '7',
        '质量标准': '11',
        '其它': '0',
        '单价（大写）': '0'
      }
    }
  },
  computed: {
    mainFileList() {
      return this.fileList.filter(f => f.fileType === 'invitation-main')
    },
    attFileList() {
      return this.fileList.filter(f => f.fileType === 'invitation-att')
    },
    canEdit() {
      return true
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    /**
     * 初始化页面
     */
    initPage() {
      this.bidInvitationDocumentsCode = this.$route.query.bidInvitationDocumentsCode
      if (!this.bidInvitationDocumentsCode) {
        this.$message.error('缺少招标文件编号参数')
        this.$router.go(-1)
        return
      }
      this.getBidInvitationDocumentsDetail()
    },

    /**
     * 获取招标文件详情
     */
    async getBidInvitationDocumentsDetail() {
      try {
        const res = await getBidInvitationDocumentsDetail({
          bidInvitationDocumentsCode: this.bidInvitationDocumentsCode
        })
        if (res.code === 200) {
          this.detailData = res.data || {}
          this.detailData.bidSectionName = res.data.bidSectionList[0].bidSectionName
          this.getFileList(res.data.fileGuid)
        } else {
          this.$message.error(res.msg || '获取招标文件详情失败')
        }
      } catch (error) {
        console.error('获取招标文件详情失败:', error)
        this.$message.error('获取招标文件详情失败，请重试')
      }
    },
    //  获取文件
    async getFileList(fileGuid) {
      if (!fileGuid) return
      try {
        const res = await getFileList(fileGuid)
        if (res.code === 200) {
          this.fileList = res.data || []
        }
      } catch (error) {
        console.error('获取文件列表失败:', error)
      }
    },

    /**
     * 格式化文件大小
     */
    formatFileSize(size) {
      if (!size || size === 0) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB', 'TB']
      let unitIndex = 0
      let fileSize = size
      while (fileSize >= 1024 && unitIndex < units.length - 1) {
        fileSize /= 1024
        unitIndex++
      }
      return `${fileSize.toFixed(unitIndex === 0 ? 0 : 2)} ${units[unitIndex]}`
    },

    /**
     * 下载文件
     */
    handleDownloadFile(fileInfo) {
      if (!fileInfo.fileUrl) {
        this.$message.error('文件下载地址不存在')
        return
      }
      try {
        const link = document.createElement('a')
        link.href = fileInfo.fileUrl
        link.download = fileInfo.fileName || '下载文件'
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.$message.success(`开始下载文件：${fileInfo.fileName}`)
      } catch (error) {
        console.error('下载文件失败:', error)
        this.$message.error('下载文件失败，请重试')
      }
    },

    /**
     * 获取文件类型文本
     */
    getDocumentTypeText(type) {
      const typeMap = { 1: '文件', 2: '补遗书', 3: '澄清文件' }
      return typeMap[type] || '-'
    },

    /**
     * 获取文件编制状态文本
     */
    getDocumentStatusText(status) {
      const statusMap = { 0: '未编制', 1: '已编制' }
      return statusMap[status] || '-'
    },

    getItemValueTypeText(valueType) {
      const valueTypeMap = { 0: '任意文本', 1: '纯数字' }
      return valueTypeMap[valueType] || '-'
    },

    getItemUnitText(unit) {
      const unitMap = { 0: '元', 1: '万元', 2: '%' }
      return unitMap[unit] || '-'
    },

    handleBack() {
      this.$router.go(-1)
    },

    // ========== 开标一览表编辑 ==========

    startEditOpening() {
      this.editOpeningList = (this.detailData.bidOpeningLists || []).map(item => ({
        ...item,
        itemName: item.itemName || '',
        itemValueType: item.itemValueType != null ? item.itemValueType : 0,
        itemUnit: item.itemUnit != null ? item.itemUnit : 0,
        itemInstructions: item.itemInstructions || ''
      }))
      this.editingOpening = true
    },

    cancelEditOpening() {
      this.editingOpening = false
      this.editOpeningList = []
    },

    addOpeningRow() {
      this.addOpeningTypeDialogData.selectedType = ''
      this.dialogs.addOpeningType = true
    },

    confirmAddOpeningRow() {
      if (!this.addOpeningTypeDialogData.selectedType) {
        this.$message.error('请选择自定义内容的类型')
        return
      }

      const selectedType = this.addOpeningTypeDialogData.selectedType
      const config = this.openingTypeConfig[selectedType]

      // 添加原有的项
      const newItem = {
        itemName: selectedType,
        itemValueType: config.valueType,
        itemUnit: config.unit,
        itemInstructions: '',
        itemType: this.openingItemTypeMap[selectedType] || '0',
        itemKey: null
      }
      this.editOpeningList.push(newItem)

      // 如果选择的是"单价"，额外添加"单价（大写）"
      if (selectedType === '单价') {
        const capitalItem = {
          itemName: '单价（大写）',
          itemValueType: 0,
          itemUnit: 0,
          itemInstructions: '',
          itemType: this.openingItemTypeMap['单价（大写）'] || '0',
          itemKey: null
        }
        this.editOpeningList.push(capitalItem)
      }

      this.dialogs.addOpeningType = false
      this.addOpeningTypeDialogData.selectedType = ''
    },

    cancelAddOpeningRow() {
      this.dialogs.addOpeningType = false
      this.addOpeningTypeDialogData.selectedType = ''
    },

    async saveOpening() {
      this.savingOpening = true
      try {
        // 参照 creatBidFile prepareFormData：补全 itemKey 和 itemType
        const bidOpeningLists = this.editOpeningList.map(function (item, index) {
          return {
            itemName: item.itemName || '',
            itemValueType: item.itemValueType != null ? item.itemValueType : 0,
            itemUnit: item.itemUnit != null ? item.itemUnit : 0,
            itemInstructions: item.itemInstructions || '',
            itemType: item.itemType != null ? item.itemType : '0',
            itemKey: item.itemKey != null ? item.itemKey : (index + 1),
            id: item.id
          }
        })
        const res = await updateBidOpeningListAndCatalogue({
          bidInvitationDocumentsCode: this.bidInvitationDocumentsCode,
          projectCode: this.detailData.projectCode || this.$route.query.projectCode,
          bidOpeningLists: bidOpeningLists
        })
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.editingOpening = false
          await this.getBidInvitationDocumentsDetail()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败，请重试')
      } finally {
        this.savingOpening = false
      }
    },

    // ========== 目录编辑 ==========

    generateStrId() {
      return 'new_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6)
    },

    // 创建新节点（不含 strId，由调用方生成）
    createNewNode(parent) {
      const isBlindReview = parent ? (parent.isBlindReview != null ? parent.isBlindReview : 0) : 0
      const bidSectionCode = parent ? (parent.bidSectionCode || '') : ''
      const parentCatalogueCode = parent ? (parent.catalogueCode || 0) : 0
      return {
        strId: this.generateStrId(),
        catalogueName: '',
        catalogueDescription: '',
        catalogueCode: null,
        catalogueParentCode: parentCatalogueCode,
        catalogueOrder: 0,
        isBlindReview: isBlindReview,
        bidSectionCode: bidSectionCode,
        children: []
      }
    },

    startEditCatalogue() {
      this.editCatalogueTree = JSON.parse(JSON.stringify(this.detailData.catalogues || []))
      this.editingCatalogue = true
    },

    cancelEditCatalogue() {
      this.editingCatalogue = false
      this.editCatalogueTree = []
    },

    // 添加根目录
    addRootNode() {
      this.editCatalogueTree.push(this.createNewNode(null))
    },

    // 添加子节点
    addChildNode(node) {
      if (!node.children) {
        this.$set(node, 'children', [])
      }
      node.children.push(this.createNewNode(node))
    },

    // 删除树节点
    removeTreeNode(parentArr, index) {
      parentArr.splice(index, 1)
    },

    // 递归处理树节点，确保字段完整（参照 creatBidFile 的 buildCataloguesTree）
    processCatalogueTree(tree, parentCode) {
      if (!Array.isArray(tree)) return []
      // 自增临时 code，从一个大值开始避免与已有真实 code 冲突
      var autoCode = 9000000
      function buildTree(nodes, pCode) {
        if (!Array.isArray(nodes)) return []
        return nodes.map(function (node, index) {
          // 已有节点保留原 code，新增节点分配临时 code
          var currentCode = (node.catalogueCode != null && node.catalogueCode !== 0)
            ? node.catalogueCode
            : (autoCode++)
          var processed = {
            catalogueCode: currentCode,
            catalogueName: node.catalogueName || '',
            catalogueDescription: node.catalogueDescription || '',
            catalogueOrder: typeof node.catalogueOrder === 'number' ? node.catalogueOrder : (index + 1),
            catalogueParentCode: pCode,
            isBlindReview: node.isBlindReview != null ? node.isBlindReview : 0,
            bidSectionCode: node.bidSectionCode || '',
            strId: node.strId,
            id: node.id
          }
          processed.children = buildTree(node.children || [], currentCode)
          return processed
        })
      }
      return buildTree(tree, parentCode != null ? parentCode : 0)
    },

    async saveCatalogue() {
      this.savingCatalogue = true
      try {
        const res = await updateBidOpeningListAndCatalogue({
          bidInvitationDocumentsCode: this.bidInvitationDocumentsCode,
          projectCode: this.detailData.projectCode || this.$route.query.projectCode,
          catalogues: this.processCatalogueTree(this.editCatalogueTree)
        })
        if (res.code === 200) {
          this.$message.success('保存成功')
          this.editingCatalogue = false
          await this.getBidInvitationDocumentsDetail()
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败，请重试')
      } finally {
        this.savingCatalogue = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

.content-wrap {
  width: 100%;
  background-color: #fff;
  padding: 20px;
  margin-top: 20px;
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

.section-block {
  margin-bottom: 30px;
  padding: 20px;
  background: #fafafa;
  border-radius: 4px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f4f7;

  &--action {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.detail-row {
  .field {
    display: flex;
    padding: 12px 0;
    line-height: 1.6;

    .label {
      min-width: 180px;
      color: #666;
      font-weight: 500;
    }

    .value {
      flex: 1;
      color: #333;
      word-break: break-all;
    }
  }
}

.catalogue-tree {
  background: #fff;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #EBEEF5;

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}

::v-deep .el-table {
  margin-top: 10px;

  th {
    background-color: #f5f7fa;
    color: #333;
    font-weight: 600;
  }

  .el-table__empty-text {
    color: #999;
  }
}

::v-deep .el-tree-node__content {
  height: 36px;
  line-height: 36px;
}

// ============================================
// 树形目录编辑样式
// ============================================
.catalogue-edit-toolbar {
  margin-bottom: 12px;
}

.catalogue-edit-tree {
  min-height: 200px;
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 12px;
  background-color: #fafafa;
}

.empty-directory {
  text-align: center;
  padding: 60px 20px;
  color: #999;

  i {
    font-size: 48px;
    color: #ccc;
    margin-bottom: 15px;
    display: block;
  }

  p {
    font-size: 14px;
    margin: 0;
  }
}

.directory-list {
  .directory-item {
    margin-bottom: 8px;

    &.child-item {
      margin-left: 30px;
      margin-top: 8px;
    }

    &.grandchild-item {
      margin-left: 30px;
      margin-top: 8px;
    }
  }

  .directory-node {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    transition: all 0.2s ease;
    gap: 8px;

    &:hover {
      background-color: #f5f7fa;
      border-color: #c0c4cc;
    }

    > i {
      color: #409EFF;
      font-size: 16px;
      flex-shrink: 0;
    }

    .dir-name-input {
      flex: 0 1 160px;
      min-width: 100px;
      max-width: 220px;
    }

    .dir-desc-input {
      flex: 1 1 80px;
      min-width: 0;
      max-width: 280px;
    }

    .directory-actions {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin-left: auto;

      .el-button {
        padding: 0;
        margin-left: 8px;
        color: #606266;

        &:hover {
          color: #409EFF;
        }
      }
    }
  }

  .directory-children {
    margin-top: 8px;
  }
}

// ============================================
// 添加开标内容弹窗样式
// ============================================
.add-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #EBEEF5;
    background: #fafafa;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }

    .el-dialog__close {
      font-size: 18px;
      color: #999;

      &:hover {
        color: #333;
      }
    }
  }

  /deep/ .el-dialog__body {
    padding: 20px;
  }

  /deep/ .el-dialog__footer {
    padding: 15px 20px 20px;
    text-align: center;
    border-top: 1px solid #EBEEF5;
  }
}

.dialog-content {
  .dialog-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 20px;
    font-weight: 500;
  }

  .type-radio-group {
    .radio-row {
      display: flex;
      margin-bottom: 15px;

      .el-radio {
        margin-right: 30px;
        margin-bottom: 0;

        .el-radio__label {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }

  .error-message {
    color: #F56C6C;
    font-size: 12px;
    margin-top: 10px;
  }
}

.dialog-footer {
  .el-button {
    padding: 10px 25px;
    font-size: 14px;
  }
}
</style>
